export default __webpack_public_path__ + "static/media/logo_satellite_primary_white_beta.83bc5481.png";